// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../style-loader/dist/cjs.js!../../css-loader/dist/cjs.js!./mapbox-gl.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("2da16dc1", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../style-loader/dist/cjs.js!../../css-loader/dist/cjs.js!./mapbox-gl.css", function() {
     var newContent = require("!!../../style-loader/dist/cjs.js!../../css-loader/dist/cjs.js!./mapbox-gl.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}